import React from "react"

const FavoriteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.4694 15.6948V11.5514C19.4694 7.99066 19.4694 6.21196 18.3754 5.10557C17.2815 4 15.5202 4 11.9993 4C8.47846 4 6.71719 4 5.62324 5.10557C4.5293 6.21113 4.5293 7.99232 4.5293 11.5514V15.6956C4.5293 18.2653 4.5293 19.551 5.13852 20.112C5.42902 20.3801 5.79588 20.5486 6.18681 20.5934C7.00603 20.6872 7.96302 19.8406 9.87618 18.1482C10.7228 17.4004 11.1453 17.0261 11.6341 16.9281C11.8748 16.8783 12.1238 16.8783 12.3645 16.9281C12.8542 17.0261 13.2767 17.4004 14.1225 18.1482C16.0356 19.8406 16.9926 20.6872 17.8118 20.5926C18.202 20.5486 18.5696 20.3801 18.8601 20.112C19.4694 19.551 19.4694 18.2653 19.4694 15.6948Z"
        stroke="#1C1F21"
        strokeWidth="1.29691"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4898 7.32031H9.50977"
        stroke="#1C1F21"
        strokeWidth="1.29691"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FavoriteIcon
